// 定制axios
import axios from 'axios'
import dajaxAdapter from './adapters/dajaxAdapter'
import addFeature from './beforeHandlers/addFeature'
import fixCompatibility from './beforeHandlers/fixCompatibility'
import setDefaultInterceptors from './defaultInterceptors'
import { type, serialize } from './utils'
// 默认dajax配置
const dajaxDefaults = {
  __dajax__: true,
  timeout: 10000,
  adapter: dajaxAdapter
}

// 扩展request
const rawRequest = axios.Axios.prototype.request
axios.Axios.prototype.request = function(config) {
  // 避免直接影响外部
  config = Object.assign({}, config)
  config.paramsSerializer = config.paramsSerializer || serialize
  config.bodySerializer = config.bodySerializer || config.paramsSerializer
  const transformRequest = config.transformRequest || []
  config.transformRequest = transformRequest.concat([function transformRequest(data, headers = {}) {
    if (typeof data === 'object' && /application\/x-www-form-urlencoded/i.test(headers['Content-Type'])) {
      return config.bodySerializer(data)
    } else {
      return data
    }
  }]).concat(axios.defaults.transformRequest)
  // 保存signWhiteList到config
  config.signWhiteList = this.signWhiteList
  // 简单处理兼容性参数
  config = fixCompatibility(config)
  // add 扩展属性
  config = addFeature(config)
  return rawRequest.call(this, config)
}
// 扩展jsonp
axios.Axios.prototype.jsonp = function(url, config) {
  config = Object.assign({url}, config, {
    method: 'jsonp'
  })
  return this.request(config)
}
// 设置签名白名单
axios.Axios.prototype.addSignWhites = function(host) {
  if (type(host) !== 'Array') {
    host = [host]
  }
  this.signWhiteList || (this.signWhiteList = [])
  this.signWhiteList.push(...host)
}
// 扩展create方法
const create = function (instanceConfig) {
  const instance = axios.create(Object.assign({}, dajaxDefaults, instanceConfig))
  setDefaultInterceptors(instance)
  return instance
}
// 创建默认配置实例
const daxios = create()
// 保存create
daxios.create = create
// 同步axios上的属性
const keys = ['Axios', 'Cancel', 'CancelToken', 'isCancel', 'all', 'spread', 'defaults']
keys.forEach(key => {
  daxios[key] = axios[key]
})

export default daxios
